import instance from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { ApiResponse, BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import { InvoicesParser } from 'pages/invoices/models';

const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class InvoicesApi extends BaseApi {
  public static getViewInvoiceUrl = async (id: number): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.invoices.viewInvoice + '?subscriptionHistoriesID=' + id
      );

      if (InvoicesApi.isResponseSuccessful(result.data)) {
        const data = result.data.details.url;
        return InvoicesApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = InvoicesParser.parseError(errors);
          return InvoicesApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = InvoicesParser.parseError(errors);
          return InvoicesApi.errorResponse(message);
        }
      }
      return InvoicesApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };
}
